import { render, staticRenderFns } from "./password.vue?vue&type=template&id=9f9fcdec&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=9f9fcdec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9fcdec",
  null
  
)

export default component.exports